/* unplugin-vue-components disabled */import { render } from "./PromocodeCampaignsTickets.vue?vue&type=template&id=41728e2c&ts=true"
import script from "./PromocodeCampaignsTickets.vue?vue&type=script&lang=ts"
export * from "./PromocodeCampaignsTickets.vue?vue&type=script&lang=ts"

import "./PromocodeCampaignsTickets.vue?vue&type=style&index=0&id=41728e2c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__